var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Largest `limit` the agency list endpoints accept (DB-876 — a bigger value is
 * rejected with HTTP 400; an omitted one falls back to 50).
 */
export var MAX_LIST_LIMIT = 100;
/** Safety cap of {@link fetchAllPages}: never load more records than this into the browser. */
export var DEFAULT_MAX_ITEMS = 5000;
/**
 * Loads a complete (small) collection page by page, for selects and lookups
 * that need every record of a bounded set (prefixes of one agency, items of one
 * ONIX codetable, numbers of one product, …) now that a single request may ask
 * for at most {@link MAX_LIST_LIMIT} records.
 *
 * Stops when `totalRecords` records are loaded, on a short or empty page, or at
 * `maxItems`. Requests run one after another, never in parallel.
 *
 * @param fetchPage loads one page for the given offset and limit
 * @param options page size and safety cap
 * @returns all loaded records, in server order
 */
export var fetchAllPages = function (fetchPage_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([fetchPage_1], args_1, true), void 0, function (fetchPage, _a) {
        var limit, all, requestLimit, _b, _c, items, totalRecords, reachedTotal;
        var _d = _a === void 0 ? {} : _a, _e = _d.pageSize, pageSize = _e === void 0 ? MAX_LIST_LIMIT : _e, _f = _d.maxItems, maxItems = _f === void 0 ? DEFAULT_MAX_ITEMS : _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    limit = Math.min(Math.max(1, pageSize), MAX_LIST_LIMIT);
                    all = [];
                    _g.label = 1;
                case 1:
                    if (!(all.length < maxItems)) return [3 /*break*/, 3];
                    requestLimit = Math.min(limit, maxItems - all.length);
                    return [4 /*yield*/, fetchPage(all.length, requestLimit)];
                case 2:
                    _b = _g.sent(), _c = _b.items, items = _c === void 0 ? [] : _c, totalRecords = _b.totalRecords;
                    all.push.apply(all, items);
                    reachedTotal = typeof totalRecords === "number" &&
                        totalRecords > 0 &&
                        all.length >= totalRecords;
                    if (items.length < requestLimit || reachedTotal)
                        return [3 /*break*/, 3];
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, all];
            }
        });
    });
};
